// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-newStudentMng-index-main_right_content-1a3-f","table":"components-newStudentMng-index-table-1HzVT","row_table":"components-newStudentMng-index-row_table-1nBoQ","col_left":"components-newStudentMng-index-col_left-1V3yh","col_right":"components-newStudentMng-index-col_right-yZGwk","blue":"components-newStudentMng-index-blue-1uUd3","photo_left":"components-newStudentMng-index-photo_left-15ZNe","photo_right":"components-newStudentMng-index-photo_right-1-nNF"};


//////////////////
// WEBPACK FOOTER
// ./components/newStudentMng/index.css
// module id = 816
// module chunks = 0